import React from "react";
import "./style.css";
import { Helmet } from "react-helmet";

//import GroupCard from "components/Groups/GroupCard";
//import { Timeline } from 'react-twitter-widgets'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Table from "react-bootstrap/Table";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Footer from "components/Footer/Footer";

import Organizer from 'components/Organizers/Organizers';

import UpcomingEvents from 'components/UpcomingEvents/UpcomingEvents';

import ManageGroupModalButton from "components/Modals/ManageGroupModalButton";
//import TitleSection from "components/TitleBar/TitleSection";
//import SpotLightPk from 'components/spotlightedPK/spotlightedPK';

//import Organizer from 'components/Organizers/Organizers';
//import { current_unix_stamp, timeStampDiff, unixTimeStamp } from "utils/Helper";


//import Help from "../../Assets/Qicon.png";
import Container from "react-bootstrap/Container";
//import Carousel from "react-bootstrap/Carousel";
//import Button from "../../components/Button/Button";
import axios from 'axios';
//import { events_list_api,search_Presentation_API,events_search_list_api, HeaderConfig, managed_contents, managed_contents_PechaKucha_Inc, myHeaders_Authorized, user_entity_uuid } from "Api/Api";
import { user_access_level, organization_user_access_level, user_Status, user_Status_Ver, org_friendly_url, apiUrl, myHeaders_Authorized, myHeaders_Auth_With_Cache_Control, user_entity_uuid } from "Api/Api";
// searchUrl, myHeaders_With_Cache_Control,
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
// import GroupListTable from "components/Groups/GroupListTable";
import {  withRouter } from "react-router-dom";
// Link,
import { local_routes } from 'utils/Routes';
//import { NavLink } from "react-router-dom";
import home from 'Assets/home.svg';

import UserContext from 'store/UserContext';

class GroupDetails extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      group_info: {users:[]},
      me_group_admin: false,
      me_in_group: false,
      other_admin: false,
      loading: true
    };
    
    this.workspace_base_url = "";
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }
  }

  /*
  componentDidUpdate (prevProps) {
    let { location: { pathname } } = this.props;

    if (prevProps.location.pathname === pathname) return;
    this.routeChanged();
  }

  routeChanged () {
      this.APICalls();
  }
  */

  componentDidMount() {
    if (user_Status === 1 && user_Status_Ver === "1") {
      this.APICalls();
    } else {
      window.location.href = '/';
    }
    //this.routeChanged();
  }

  //componentDidMount = async function () {
  APICalls = async function () {
    console.log("Groups APICalls",org_friendly_url);
    //this.setState({
      //loading: true
    //});

    let new_state = {...this.state};

    // API Calls starts here
    let api_promises = [];
    api_promises.push(axios.get(`${apiUrl}groups/${this.props.match.params.friendly_url}`,myHeaders_Authorized));
    api_promises.push(axios.get(`${apiUrl}groups/${this.props.match.params.friendly_url}/users`,myHeaders_Authorized));
    api_promises.push(axios.get(`${apiUrl}groups/${this.props.match.params.friendly_url}/events`,myHeaders_Authorized));
    
    let [group_info_response, group_users_response, group_events_response] = await Promise.all(api_promises);

    new_state.group_info = group_info_response.data;
    
    new_state.group_info.users = group_users_response.data;
    
    new_state.group_info.events = group_events_response.data;
    
    new_state.group_info.events = new_state.group_info.events.sort((a, b) => (a.start_time < b.start_time) ? 1 : -1);
    
    // are we in group? Can we manage it?
    let me_group_info = new_state.group_info.users.find( element => element.entity_uuid === user_entity_uuid );
    console.log("me_group_info",me_group_info);
    if (me_group_info) {
      new_state.me_in_group = true;
      if (me_group_info.xref_data && me_group_info.xref_data.entity_owner_integer) {
        new_state.me_group_admin = true;
      }
    } else {
      new_state.me_in_group = false;
    }
    
    if (organization_user_access_level === 'admin' || user_access_level === 'admin') {
      new_state.other_admin = true;
    }
    
    if (new_state.group_info.image_url) {
      let pad_color = "black";
      let image_size = '1280x720';
      let array = new_state.group_info.image_url.split("/");
      new_state.group_info.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/pad${pad_color}_${image_size}/${array[5]}`;
    }

    new_state.loading = false;
    
    this.setState(new_state);
  }

  onSaveCallback = () => {
    this.APICalls();
  }
  
  leaveGroup = async () => {
    console.log("leaveGroup");

    await axios.delete(`${apiUrl}users/${user_entity_uuid}/groups/${this.state.group_info.entity_uuid}`);
    
    // bust cache
    await Promise.all([
      axios.get(`${apiUrl}groups/${this.props.match.params.friendly_url}/users`,myHeaders_Auth_With_Cache_Control),
      axios.get(`${apiUrl}users/${user_entity_uuid}/groups`,myHeaders_Auth_With_Cache_Control)
    ]);
    
    await this.APICalls();
  }

  joinGroup = async () => {
    console.log("joinGroup");
    let post_obj = {
      entity_reader_integer: 1
    };
    await axios.patch(`${apiUrl}users/${user_entity_uuid}/groups/${this.state.group_info.entity_uuid}`,post_obj);
    
    // bust cache
    await Promise.all([
      axios.get(`${apiUrl}groups/${this.props.match.params.friendly_url}/users`,myHeaders_Auth_With_Cache_Control),
      axios.get(`${apiUrl}users/${user_entity_uuid}/groups`,myHeaders_Auth_With_Cache_Control)
    ]);
    
    await this.APICalls();
  }

  render() {
    if (this.state.loading === true || !this.context.user_info.entity_uuid) {
      return (
        <ActivityIndicator theme="spinner" />
      );
    }
    
    return (
      <React.Fragment>
        <Helmet>
          <title>Pecha Kucha 20x20: Groups</title>
        </Helmet>
        <Container style={{ marginTop: "10px" }}>
          <Row className="justify-content-between">
            <Col xs={8}>
              <h2>{this.state.group_info.entity_name}</h2>
            </Col>
            <Col xs="auto">
              {(this.state.me_in_group && !this.state.me_group_admin) &&
                <Button
                  variant="pkprimary"
                  onClick={this.leaveGroup}
                >
                  Leave Group
                </Button>
              }
              {!this.state.me_in_group &&
                <Button
                  variant="pkprimary"
                  onClick={this.joinGroup}
                >
                  Join Group
                </Button>
              }
              &nbsp;
              {(this.state.me_group_admin || this.state.other_admin) &&
                <ManageGroupModalButton
                  group_info={this.state.group_info}
                  onSaveCallback={this.onSaveCallback}
                />
              }
            </Col>
          </Row>
          <Row style={{ marginTop: "15px" }}>
            {this.state.group_info.adjusted_image_url &&
              <Col xs={12} md={6}>
                <Image
                  fluid
                  rounded
                  src={this.state.group_info.adjusted_image_url}
                />
              </Col>
            }
            <Col xs={12} md={6}>
              {this.state.group_info.description}
            </Col>
          </Row>
          { this.state.group_info.events &&
            <Row style={{ marginTop: "15px" }}>
            { this.state.group_info.events.map((item) =>
              <Col lg={4} key={item.entity_uuid}>
                <UpcomingEvents
                  //key={item.entity_uuid}
                  event_info={item}
                  //id={item.entity_uuid}
                  Event_img={item.thumb_image_url || item.poster_image_url}
                  //Event_time={item.event_days_left}
                  //Event_month={item.Event_month}
                  //Event_year={item.Event_year}
                  //Event_date={item.Event_date}
                  Event_title={item.entity_name}
                  //Event_place={item.locations_text}
                  //Event_vol={item.volume_integer}
                  //Event_slot={item.Event_slot}
                  Event_link={`${this.workspace_base_url}${local_routes.events}/${item.friendly_url}`}
                />
              </Col>
            )}
            </Row>
          }
          <Row style={{ marginTop: "15px" }}>
                    {
                      this.state.group_info.users.map((item, index) =>
                        <Col key={index} sm={12} md={6} lg={6}>
                          <Organizer
                            show_Icon={false}
                            Organizer_firstname={item.firstname}
                            Organizer_lastname={item.lastname}
                            Organizer_text={item.description}
                            admin_flag={item.xref_data && item.xref_data.entity_owner_integer ? true : false}
                            profile_pic={item.avatar_image_url}
                            Organizer_link={
                              (item.friendly_url !== undefined && item.friendly_url !== null) ? `${this.workspace_base_url}${local_routes.users}/${item.friendly_url}`
                              : null
                            }
                          />
                        </Col>
                      )}          
          </Row>
        </Container>
        <Footer 
            homeImg={home}
            homeImgRef={this.workspace_base_url ? this.workspace_base_url : "/"}
            breadcrumbMainPage="Groups"
            breadcrumbSubPage="Group Detail"
            mainPageLink={this.workspace_base_url+local_routes.groups}
        />
      </React.Fragment>
      );
    }

}

export default withRouter(GroupDetails);
